export const DEFAULT_STYLES = {
  hubBodyFontFamily: 'Roboto',
  headerCentreLogo: false,
  hubHeadlineFontFamily: 'Roboto',
  headerBackgroundColor: '#222',
  footerFontColor: '#434343',
  streamIconColor: 'rgb(184, 193, 202)',
  coverTintColor: 'black',
  coverTintColorWithOpacity: 'rgba(0, 0, 0, 1)',
  hubHeadlineFontStyle: 'normal',
  hubDetailFontColor: '#758386',
  coverBackgroundColor: '#000',
  hubBodyFontLetterSpacing: 'normal',
  coverShowTitle: true,
  hubDetailFontStyle: 'normal',
  streamBackgroundColor: '#fff',
  headerFontColor: 'white',
  coverFontColor: '#fff',
  collectionsFontColor: '#454B4F',
  hubLinkFontColor: 'rgb(30, 30, 30)',
  hubDetailFontWeight: 'normal',
  headerAccentColor: '#fff',
  hubMenuFontWeight: 'normal',
  hubBodyFontWeight: 'normal',
  headerIconColor: 'white',
  footerBackgroundColor: '#fff',
  hubHeadlineFontColor: '#212932',
  collectionsBackgroundColor: 'rgba(255, 255, 255, 0.96)',
  hubAccentColor: '#0C8EF0',
  hubBodyFontColor: '#6B7278',
  streamTileBackdropColor: '#eee',
  hubBodyFontStyle: 'normal',
  headerLogoImage: null,
  coverHideCover: false,
}
